/** @jsx jsx */
import { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { Flex, jsx } from 'theme-ui'
import { useAuth } from '@chordcommerce/gatsby-theme-autonomy'
import NavMenuLogo from './Logo'
import NavMenuCartLink from './CartLink'
import NavMenuLinks from './Links'
import NavMenuLink from './Link'
import NavMenuToggle from './Toggle'
import { getLoginUrl, isStorageLoggedIn } from '~/utils/auth'

const NavMenu = ({ pages, isTrade, itemCount, jumpCta }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { isLoggedIn } = useAuth()
  const showAccountLinks = isLoggedIn || isStorageLoggedIn()

  const accountLink = !showAccountLinks
    ? {
        id: 'login',
        name: 'Club Login',
        slug: getLoginUrl(),
      }
    : {
        id: 'account',
        title: 'Account',
        pages: [
          {
            id: 'club',
            name: 'Can Club',
            slug: 'account/club',
          },
          {
            id: 'orders',
            name: 'Order history',
            slug: 'account/orders',
          },
          {
            id: 'community',
            name: 'Community',
            slug: 'account/community',
          },
          {
            id: 'referrals',
            name: 'Refer a friend',
            slug: 'account/referrals',
          },
          {
            id: 'account',
            name: 'Account',
            slug: 'account/account',
          },
          {
            id: 'logout',
            name: 'Log out',
            slug: 'account/logout',
          },
        ],
      }

  return (
    <Flex
      sx={{
        alignItems: 'center',
        color: 'inherit',
        height: '100%',
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      {!jumpCta && (
        <Fragment>
          <NavMenuToggle onClick={() => setIsOpen(!isOpen)} isOpen={isOpen} />
          <NavMenuLogo isTrade={isTrade} />
          <Flex
            sx={{
              alignItems: [null, null, 'center'],
            }}
          >
            <NavMenuLinks isOpen={isOpen}>
              {pages.map((page) => (
                <NavMenuLink
                  page={page}
                  key={page.id}
                  closeParentMenu={() => setIsOpen(false)}
                />
              ))}
              {!isTrade && (
                <NavMenuLink
                  key="account"
                  page={accountLink}
                  closeParentMenu={() => setIsOpen(false)}
                />
              )}
            </NavMenuLinks>
            {!isTrade && <NavMenuCartLink itemCount={itemCount} />}
          </Flex>
        </Fragment>
      )}
      {jumpCta && (
        <Fragment>
          <NavMenuLogo />
          {jumpCta}
        </Fragment>
      )}
    </Flex>
  )
}

NavMenu.propTypes = {
  pages: PropTypes.array,
  itemCount: PropTypes.number,
  showItemCount: PropTypes.bool,
}

export default NavMenu
